<template>
    <div>
        <vSelect :options="directionOptions" v-model="direction" :reduce="label => label.code" label="label" :disabled="disabled" />
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    name: "DirectionSelect",
    components: {
        vSelect
    },
    props: {
        value: null,
        maxValue: { default: 2 },
        disabled: {type: Boolean, default: false}
    },
    computed: {
        directionOptions: function() {
            var directionList = [];

            for( var i = 0; i <= this.maxValue; i++) {
                directionList.push({code: i, label: i})
            }

            return directionList;
        },
        direction: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        },
    },
}
</script>